<div class="page main col{{ columns }}">
  @if ((loading$ | async) === false) {
    @if (appConfig$ | async; as appConfig) {
      @if (easyEcommerceTemplates$ | async; as easyEcommerceTemplates) {
        @if (easyEcommerceTemplates.length > 0 && !!appConfig.config.showIncludedTemplates) {
          <span class="title">
            {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.ECOMMERCE.TITLE' | translate }}
          </span>
          <span class="subtext">
            {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.ECOMMERCE.ONLINE_STORE_INFO' | translate }}
          </span>
          <span class="subtext">
            <img src="{{ this.starImage }}" alt="" />
            <span [innerHTML]="'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.ECOMMERCE.SUBTITLE' | translate"></span>
          </span>
          <mat-grid-list [cols]="columns" [rowHeight]="rowHeight" (window:resize)="onResize($event)">
            @for (template of easyEcommerceTemplates; track template) {
              <mat-grid-tile>
                <app-template-card
                  [template]="template"
                  [canEdit]="false"
                  [canDelete]="false"
                  [icon]="this.starImage"
                  [templateSelect]="true"
                  (selected)="selectTemplate($event)"
                ></app-template-card>
              </mat-grid-tile>
            }
          </mat-grid-list>
        }
      }
      @if (standardTemplates$ | async; as standardTemplates) {
        @if (standardTemplates.length > 0 && !!appConfig.config.showIncludedTemplates) {
          <br />
          <span class="title">
            {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.STANDARD.TITLE' | translate }}
          </span>
          <span class="subtext"></span>
          <mat-grid-list [cols]="columns" [rowHeight]="rowHeight" (window:resize)="onResize($event)">
            @for (template of standardTemplates; track template) {
              <mat-grid-tile>
                <app-template-card
                  [template]="template"
                  [canEdit]="false"
                  [canDelete]="false"
                  [templateSelect]="true"
                  (selected)="selectTemplate($event)"
                ></app-template-card>
              </mat-grid-tile>
            }
          </mat-grid-list>
        }
      }
      @if (partnerTemplates$ | async; as partnerTemplates) {
        @if (partnerTemplates.length > 0) {
          <br />
          <span class="title">
            {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.PARTNER_CREATED.TITLE' | translate }}
          </span>
          @if (isSuperAdmin$ | async) {
            <span class="subtext">
              {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.PARTNER_CREATED.SUBTITLE' | translate }}
            </span>
          }
          <mat-grid-list [cols]="columns" [rowHeight]="rowHeight" (window:resize)="onResize($event)">
            @for (template of partnerTemplates; track template.siteId) {
              <mat-grid-tile>
                <app-template-card
                  [template]="template"
                  [canEdit]="false"
                  [canDelete]="false"
                  [templateSelect]="true"
                  (selected)="selectTemplate($event)"
                ></app-template-card>
              </mat-grid-tile>
            }
          </mat-grid-list>
        }
      }
      @if (nonDistributedTemplates$ | async; as nonDistributedTemplates) {
        @if (nonDistributedTemplates.length > 0) {
          <br />
          <span class="title">
            {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.NON_DISTRIBUTED.TITLE' | translate }}
          </span>
          <span class="subtext">
            {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.NON_DISTRIBUTED.SUBTITLE' | translate }}
          </span>
          <mat-grid-list [cols]="columns" [rowHeight]="rowHeight" (window:resize)="onResize($event)">
            @for (template of nonDistributedTemplates; track template.siteId) {
              <mat-grid-tile>
                <app-template-card
                  [template]="template"
                  [canEdit]="false"
                  [canDelete]="false"
                  [templateSelect]="true"
                  (selected)="selectTemplate($event)"
                ></app-template-card>
              </mat-grid-tile>
            }
          </mat-grid-list>
        }
      }
      @if (marketingTemplates$ | async; as marketingTemplates) {
        @if (marketingTemplates.length > 0 && !!appConfig.config.showIncludedTemplates) {
          <br />
          <span class="title">
            {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.MS_CREATED.TITLE' | translate }}
          </span>
          <span class="subtext">
            {{ 'PAGES.CREATE_FROM_TEMPLATES.TEMPLATE_SECTIONS.MS_CREATED.SUBTITLE' | translate }}
          </span>
          <mat-grid-list [cols]="columns" [rowHeight]="rowHeight" (window:resize)="onResize($event)">
            @for (template of marketingTemplates; track template) {
              <mat-grid-tile>
                <app-template-card
                  [template]="template"
                  [canEdit]="false"
                  [canDelete]="false"
                  [templateSelect]="true"
                  (selected)="selectTemplate($event)"
                ></app-template-card>
              </mat-grid-tile>
            }
          </mat-grid-list>
        }
      }
    }
  } @else {
    <mat-grid-list [cols]="columns" [rowHeight]="rowHeight" (window:resize)="onResize($event)">
      @for (i of [1, 2, 3]; track i) {
        <mat-grid-tile>
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>
                <div class="stencil-line-large stencil-shimmer"></div>
              </mat-card-title>
            </mat-card-header>
            <div>
              <mat-spinner class="info-spinner" color="accent" [diameter]="60" [strokeWidth]="8"></mat-spinner>
            </div>
          </mat-card>
        </mat-grid-tile>
      }
    </mat-grid-list>
  }
</div>
